import React, {Component} from 'react';

export default class ContentIsCreatedNotCurated extends Component {
    render(){
        return(
            <div className='gr-12 content-is-created-not-curated'>
                <div className='gr-5 push-1 content-is-created-not-curated-text'>
                    <h1>Content is created not curated for your brand</h1>
                    <p>Get the best branded content in the world minus the hassle of looking for it. Social Native's proprietary technology automates the entire creative process.</p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/branded_content/content_is_created_not_curated.js